import Footer from "../components/footer";
import Header from "../components/header";
import SideNavReSeller from "../components/sidenavReSeller";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import PageHeader from "../components/pageHeader";
import { useParams, useNavigate } from "react-router-dom";

const ArtworkReSellerAll = () => {

    let userInfo = JSON.parse(localStorage.getItem('admin-info'));
    const navigate = useNavigate();
    const [artworkData, setArtworkData] = useState([]);


    const [newdata, setNewdata] = useState({
        artworkID: 0, artistID: 0, statusID: 0, filterChoiceID: 0
    });

    const fetchData = async (url, setData) => {
        try {
            const response = await fetch(url);
            const data = await response.json();
            setData(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const fetchDataFiltered = async () => {

        const url = `https://igapi.heuristticminds.com/api/ProductList/Get-GetAllArtworkByOwnerID?ownerid=${userInfo.user_id}`;
        fetchData(url, setArtworkData);
    };

    useEffect(() => {
        fetchDataFiltered(); // Fetch filtered data when component mounts and when filter values change
    }, [newdata]);

    const onChangeHandle = (e) => {
        const { name, value } = e.target;
        setNewdata(prevState => ({
            ...prevState,
            [name]: parseInt(value, 10)
        }));
    };

    const columns = [
        {
            name: "ID",
            selector: row => row.id,
            sortable: true,
            width: "80px",
        },
        {
            name: "Artwork",
            cell: (row) => <img className="m-2" src={`../images/products/full/${row.image}`} alt=" " width="80px" />,
            width: "100px",
        },
        {
            name: "Artwork Title",
            selector: row => row.productTitle,
            sortable: true,
            width: "180px",
        },
        {
            name: "Artist Name",
            selector: row => row.artistName,
            sortable: true,
            width: "150px",
        },
        {
            name: "Price",
            selector: (row) => row.price,
            width: "100px",
        },
        {
            name: "Created On",
            selector: row => new Date(row.createdOn).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }),
            sortable: true,
            width: "120px",
        },
        {
            name: "Status",
            selector: (row) => row.statusName,
            width: "100px",
        },
        {
            name: "Action",
            cell: (row) => <>
                <button className="btn btn-light me-2 tp" onClick={(event) => onEditClick(event, row.id)}
                    disabled={row.statusName != 'InActive' || row.is_lock === 2} // Disable if statusID = 4 or is_Lock = 2
                >
                    <span className="tptitle">Edit Product</span>
                    <i className="bi bi-pencil-square"></i>
                </button>
                <button className="btn btn-light tp text-primary me-2" onClick={(event) => onViewClick(event, row.id)}>
                    <span className="tptitle">View</span>
                    <i className="bi bi-eye-fill"></i>
                </button>
                <button className="btn btn-light tp text-primary" onClick={(event) => onUploadClick(event, row.id)}
                    disabled={row.statusName != 'InActive' || row.is_lock === 2} // Disable if statusID = 4 or is_Lock = 2
                >
                    <span className="tptitle">Upload Artwork</span>
                    <i className="bi bi-upload"></i>
                </button>
            </>
        },
    ];

    const onUploadClick = (event, id) => {
        event.preventDefault(); // Prevents the default behavior of the link
        navigate(`/uploadArtworkReSeller/${id}`);
    };

    const onViewClick = (event, id) => {
        event.preventDefault();
        navigate(`/viewReSellerArtworkDetails/${id}`);
    };

    const onEditClick = (event, id) => {
        event.preventDefault();
        navigate(`/addArtworkReSeller/${id}/1`);
    };

    const onIsLockClick = async (id, isLock) => {
        const confirmed = window.confirm(`Are you sure you want to ${isLock === 0 ? 'Unlock' : 'Lock'} the Artwork?`);
        if (!confirmed) return;

        try {
            const url = `https://igapi.heuristticminds.com/api/ProductList/Update-ProductIsLockByID?id=${id}`;
            const response = await fetch(url, { method: 'PUT' });
            if (response.ok) {
                fetchDataFiltered();
            } else {
                console.log('Failed to update data');
            }
        } catch (error) {
            console.log('Error updating data', error);
        }
    };

    return (
        <>
            <Header />
            <div id="layoutSidenav">
                <SideNavReSeller />
                <div id="layoutSidenav_content">
                    <div>
                        <PageHeader name='All Artwork' icon='bi bi-people-fill' />
                        <div className="container-xl px-4">
                            <div className="row">
                                <div className="col-lg-12 mb-4">
                                    <div className="card mb-4 h-100">
                                        <div className="card-header">List Of Artwork</div>
                                        <div className="card-body">
                                            <div className="row mb-4">
                                                <div className="col-sm-12">
                                                    <a href="/addArtworkReSeller" className="btn btn-primary">
                                                        <i className="bi bi-plus-circle-fill"></i> Add Artwork
                                                    </a>
                                                </div>
                                            </div>

                                            <DataTable columns={columns} data={artworkData} pagination />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </>
    );
};

export default ArtworkReSellerAll;
